import { Avatar as MantineAvatar } from '@mantine/core';

export const Avatar = MantineAvatar.extend({});
